<template>
  <div class="form-group">
    <VueTelInput
      v-model="phoneNumber"
      :default-country="defaultCountry"
      :dropdown-options="{
        'showDialCodeInList':true,
        'showDialCodeInSelection':false,
        'showFlags':true,
        'showSearchBox':true,
      }"
      :input-options="{
        'autofocus':true,
        'showDialCode':true,
        'placeholder':'+54 9 11 3288 4589',
        'required':true,
      }"
      :mode="'international'"
      :valid-characters-only="true"
      @validate="validatePhoneNumber"
    />
    <i
      :class="userPhoneIcon"
      aria-hidden="true"
    />
  </div>
</template>
<script>
import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

export default {
  name: 'TelephoneInput',
  components: {
    VueTelInput,
  },

  props: {
    userPhoneNumber: {
      type: String,
      required: false,
    },
    defaultCountry: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      userPhoneIcon: null,
      telephone_cc: '',
      telephone: '',
      phoneNumber: '',
    };
  },
  created() {
    if (this.userPhoneNumber !== '' && this.userPhoneNumber != null) {
      this.phoneNumber = `${this.userPhoneNumber}`;
    }
  },
  methods: {
    validatePhoneNumber(phoneObject) {
      if (phoneObject.valid) {
        this.telephone = phoneObject.nationalNumber;
        this.telephone_cc = phoneObject.countryCallingCode;
        this.userPhoneIcon = 'icon-check-1 text-success';
        this.bookErrors = {};
        this.$emit('userPhoneUpdated', { telephone: this.telephone });
        this.$emit('userPhoneUpdated', { telephone_cc: this.telephone_cc });
      } else {
        this.telephone = null;
        this.telephone_cc = null;
        this.userPhoneIcon = 'icon-cancel-1 text-danger';
      }
    },
  },
};
</script>
<style scoped>

</style>
